import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/root.types';
import { ServerlessApiKey } from 'sync/access-service';

export const serverlessApiKeySliceName = 'serverlessApiKey';

const getInitialState = () => ({ key: null as ServerlessApiKey | null });

export const serverlessApiKeySlice = createSlice({
  name: serverlessApiKeySliceName,
  initialState: getInitialState(),
  reducers: {
    setKey(state, { payload: key }: PayloadAction<ServerlessApiKey | null>) {
      state.key = key;
    },
    resetKey(state) {
      Object.assign(state, getInitialState());
    },
  },
});

export const { setKey, resetKey } = serverlessApiKeySlice.actions;
export default serverlessApiKeySlice.reducer;

export const selectKey = (state: RootState): ServerlessApiKey | null => {
  return state[serverlessApiKeySliceName].key;
};
